export default "__VITE_ASSET__DZjTN7FX__"